(function (angular) {
    'use strict';

    angular.module('integration')

        /**
         *
         */
        .factory('accessTokenService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = 'http://localhost:8001';
                    var fac = {
                        getAvailablePermissions: getAvailablePermissions,
                        getAvailableTemplates: getAvailableTemplates,
                        getAccessToken: getAccessToken,
                        deleteAccessToken: deleteAccessToken,
                        getAccessTokens: getAccessTokens,
                        createAccessToken: createAccessToken
                    };

                    return fac;

                    /**
                     * GET "/apispace/{id}/accesstokens/availablepermissions"
                     * @param {string} id - the api space Id
                     */
                    function getAvailablePermissions(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/accesstokens/availablepermissions")
                            .then(getAvailablePermissionsComplete)
                            .catch(getAvailablePermissionsFailed);

                        function getAvailablePermissionsComplete(response) {
                            return response.data;
                        }

                        function getAvailablePermissionsFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispace/{id}/accesstokens/availablepermissions"
                     * @param {string} id - the api space Id
                     */
                    function getAvailableTemplates(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/accesstokens/availabletemplates")
                            .then(getAvailableTemplatesComplete)
                            .catch(getAvailableTemplatesFailed);

                        function getAvailableTemplatesComplete(response) {
                            return response.data;
                        }

                        function getAvailableTemplatesFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispace/{id}/accesstokens"
                     * @param {string} id - the api space Id
                     */
                    function getAccessTokens(id) {

                        return $http.get(urlBase + "/apispaces/" + id + "/accesstokens")
                            .then(getAccessTokensComplete)
                            .catch(getAccessTokensFailed);

                        function getAccessTokensComplete(response) {
                            return response.data;
                        }

                        function getAccessTokensFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * GET "/apispace/{id}/accesstokens"
                     * @param {string} id - the api space Id
                     * @param {string} tokenId - the access token id
                     */
                    function getAccessToken(id, tokenId) {

                        return $http.get(urlBase + "/apispaces/" + id + "/accesstokens/" + tokenId)
                            .then(getAccessTokenComplete)
                            .catch(getAccessTokenFailed);

                        function getAccessTokenComplete(response) {
                            return response.data;
                        }

                        function getAccessTokenFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * POST "/apispace/{id}/accesstokens"
                     * @param {string} id - the api space Id
                     * @param {object} data - data to create access token
                     */
                    function createAccessToken(id, data) {

                        return $http.post(urlBase + "/apispaces/" + id + "/accesstokens", data)
                            .then(createAccessTokenComplete)
                            .catch(createAccessTokenFailed);

                        function createAccessTokenComplete(response) {
                            return response.data;
                        }

                        function createAccessTokenFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }

                    /**
                     * DELETE "/apispace/{id}/accesstokens/{tokenId}"
                     * @param {string} id - the api space Id
                     * @param {string} tokenId - the access token id
                     */
                    function deleteAccessToken(id, tokenId) {

                        return $http.delete(urlBase + "/apispaces/" + id + "/accesstokens/" + tokenId)
                            .then(deleteAccessTokenComplete)
                            .catch(deleteAccessTokenFailed);

                        function deleteAccessTokenComplete(response) {
                            return response.data;
                        }

                        function deleteAccessTokenFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }

                    }
                }]);

})(window.angular);
